const fr_FR = {
    "title-bold": "Calculateur",
    "title-light": "de tolérance",
    "subtitle-bold": "types de",
    "subtitle-light": "tolérances ISO",
    "holes": "trous",
    "shafts": "axes",
    "nominal-size": "dimension nominale",
    "letter": "lettre",
    "number": "numéro",
    "calculate": "calculer",
    "diameter-must-be-more-than-zero": "Le diamètre doit être supérieur à 0",
    "letter-number-combination-not-found": "Combinaison Lettre-Numéro n'a pas été trouvée",
    "results": "résultats",
    "inferior-measure": "inférieur",
    "inferior-measure-expanded": "mesure inférieure",
    "superior-measure": "supérieure",
    "superior-measure-expanded": "mesure supérieure",
    "average": "moyenne",
    "tolerance-range": "intervalle",
    "tolerance-range-expanded": "intervalle de tolérance",
    "not-exist": "Il n'y a pas de valeurs"
}


export default fr_FR;